import { ReactNode } from 'react';
import { Spark, SparkTone } from './Spark';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  delta?: string;
  deltaDirection?: 'up' | 'down' | 'neutral';
  spark?: number[];
  sparkTone?: SparkTone;
}

export function StatTile({
  label,
  value,
  delta,
  deltaDirection,
  spark,
  sparkTone = '',
}: StatTileProps) {
  const dir =
    deltaDirection ||
    (typeof delta === 'string' && delta.trim().startsWith('−') ? 'down' : 'up');
  return (
    <div className="ds-card">
      <div className="ds-stat">
        <div className="ds-stat-label">{label}</div>
        <div className="ds-stat-value">{value}</div>
        {delta ? (
          <div className={`ds-stat-delta ds-delta-${dir}`}>{delta}</div>
        ) : null}
        {spark && spark.length > 0 ? (
          <div className="ds-stat-spark">
            <Spark values={spark} tone={sparkTone} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default StatTile;
